import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppSettings } from '../../../../app.settings';

@Injectable({
  providedIn: 'root'
})
export class EmailrecordService {
 // Base_url = 'http://mtrx-svr928.matrix.local/api/';
  Base_url = `${AppSettings.EMAIL_API_ENDPOINT}`;
  emailDataUrl = this.Base_url+'/emails/table';
  emailQAScoreUrl = this.Base_url+'/email';
  emailTranscriptUrl = this.Base_url+'/get-email-text';
  updateManualScoreUrl = this.Base_url+'/email/update_manual_score';
  mailsendUrl = this.Base_url+'/email/sendmail';
  deleteEmailTableUrl = this.Base_url+'/emails/group';
 emailDataContent = this.Base_url+'/emails';
  attachmentFile= this.Base_url+'/attachment';
  emailRead = this.Base_url+'/email/';
  emailCategoryUrl = this.Base_url+'/get-email-category/';


  constructor(private http: HttpClient) { }

  getEmailData(payload:any){
   return this.http.post(this.emailDataUrl,payload);
  }

  getTranscriptData(id: string){
    return this.http.get(`${this.emailTranscriptUrl}/${id}`);
  }

  deleteEmailData(id:string){
    return this.http.delete(`${this.deleteEmailTableUrl}/${id}`);
  }

  getQAScoreEmail(id:string){
    return this.http.get(`${this.emailQAScoreUrl}/${id}`);
  }

  // getEmailDeleteData(value) {
  //   return this.http.get(`${this.logUrl}/remove-email-byid/${value}`);
  // }

  updateManualScore(payload:any){
    return this.http.post(`${this.updateManualScoreUrl}`,payload);
  }

  sendMailReply(payload:any){
    return this.http.post(this.mailsendUrl,payload);
  }


  getEmailContent(payload:any){
     return this.http.post(this.emailDataContent,payload);
  }

  getAttachementFile(fileName:any){
    return this.http.get(this.attachmentFile+'/'+fileName,{responseType:'blob'});
  }

  secureReadfile(url: string):Observable<Blob>{
    return this.http.get(url, { responseType: 'blob' })
  }

  setEmailRead(email_id:any){
    return this.http.put(this.emailRead+email_id+'/read',{});
  }

  getXlsData(fileUrl:any){
    return this.http.get(fileUrl);
  }

  getEmailCategoryById(email_id:any){
    return this.http.get(this.emailCategoryUrl+email_id);
  }

  getXls(Url:any){
    return this.http.get(Url, { responseType: 'arraybuffer' });
  }



}
